// extracted by mini-css-extract-plugin
export default {"screen":"layer-switch_screen__ZbHm2","trigger":"layer-switch_trigger__FS9DV","download":"layer-switch_download__QbtgM"};